import React, { useState } from 'react';
import ModalBase from '../ModalBase';
import EquipamentosAba from './config/EquipamentosAba';
import CamerasAba from './config/CamerasAba';
import GruposAba from './config/GruposAba';
import ToursAba from './config/ToursAba';
import MapasAba from './config/MapasAba';

// Configuracao do modulo de cameras (permissao admin:cameras).

const ABAS = [
  { id: 'equipamentos', rotulo: 'Equipamentos', icone: 'bi-hdd-rack', Componente: EquipamentosAba },
  { id: 'cameras', rotulo: 'Câmeras', icone: 'bi-camera-video', Componente: CamerasAba },
  { id: 'grupos', rotulo: 'Grupos', icone: 'bi-tags', Componente: GruposAba },
  { id: 'tours', rotulo: 'Tours', icone: 'bi-collection-play', Componente: ToursAba },
  { id: 'mapas', rotulo: 'Mapas', icone: 'bi-map', Componente: MapasAba },
];

export default function ConfigCameras({ onClose }) {
  const [aba, setAba] = useState('equipamentos');
  // Algo mudou: a tela de cameras recarrega o catalogo ao fechar.
  const [alterou, setAlterou] = useState(false);
  const { Componente } = ABAS.find((a) => a.id === aba);

  return (
    <ModalBase titulo="Configurar câmeras" onClose={() => onClose(alterou)} largura={1080}>
      <nav className="cameras-config__abas" role="tablist">
        {ABAS.map((a) => (
          <button
            key={a.id}
            type="button"
            role="tab"
            aria-selected={aba === a.id}
            className={`cameras-config__aba ${aba === a.id ? 'cameras-config__aba--ativa' : ''}`}
            onClick={() => setAba(a.id)}
          >
            <i className={`bi ${a.icone}`} /> {a.rotulo}
          </button>
        ))}
      </nav>
      <Componente key={aba} onAlterou={() => setAlterou(true)} />
    </ModalBase>
  );
}
